// extracted by mini-css-extract-plugin
export default {"innerWrapper":"sw-z","tooltipWrapper":"tw-z","icon":"uw-z","tooltip":"vw-z","content":"ww-z"};